<script>
import Layout from '@/views/layouts/main'
import PageHeader from '@/components/page-header'
import { http } from '@/helpers/easyindustriaapi/config'

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      titleBody: 'Rel. Contas a Receber',
      items: [
        { text: 'Financeiro', href: '/financeiro' },
        { text: 'Rel. Contas a Receber', active: true }
      ],
      currentEmpresa: null,
      // Visualização de PDF
      pdfSrc: null,
      isLoadingPdf: false,
      pdfError: null,
      // UI
      showFilters: true,
      filters: {
        vencimento_de: null,
        vencimento_ate: null,
        recebimento_de: null,
        recebimento_ate: null,
        competencia_mes: null,
        competencia_ano: null,
        status: null,
      }
    }
  },
  created() {
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
  },
  methods: {
    onPrimaryButtonClick() {
      if (!this.showFilters) {
        // volta para filtros e limpa PDF
        this.showFilters = true
        this.clearPdf()
        this.isLoadingPdf = false
        this.pdfError = null
        return
      }
      this.generateReport()
    },
    async generateReport() {
      try {
        this.pdfError = null
        this.isLoadingPdf = true
        this.clearPdf()

        const payload = { ...this.filters, empresa_id: this.currentEmpresa?.id }
        const response = await http.post('/relatorios/contas-a-receber/contas-recebidas', payload, { responseType: 'blob' })

        const contentType = response.headers?.['content-type'] || response.headers?.get?.('content-type')
        if (contentType && contentType.includes('application/pdf')) {
          this.setPdfFromBlob(response.data)
          this.showFilters = false
        } else {
          this.pdfError = 'Não foi possível gerar o PDF do relatório.'
        }
      } catch (e) {
        this.pdfError = 'Erro ao gerar relatório. Verifique os filtros e tente novamente.'
      } finally {
        this.isLoadingPdf = false
      }
    },
    // Helpers PDF
    clearPdf() {
      if (this.pdfSrc && this.pdfSrc.startsWith('blob:')) {
        URL.revokeObjectURL(this.pdfSrc)
      }
      this.pdfSrc = null
      this.pdfError = null
    },
    setPdfFromBlob(blob) {
      this.clearPdf()
      this.pdfSrc = URL.createObjectURL(blob)
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="titleBody" :items="items" />
    <div class="row" v-show="showFilters">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-card>
              <div class="row mb-3">
                <div class="col-md-3">
                  <b-form-group label="Vencimento de:">
                    <b-form-input type="date" v-model="filters.vencimento_de" />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Vencimento até:">
                    <b-form-input type="date" v-model="filters.vencimento_ate" />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Recebido de:">
                    <b-form-input type="date" v-model="filters.recebimento_de" />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Recebido até:">
                    <b-form-input type="date" v-model="filters.recebimento_ate" />
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <b-form-group label="Competência Mês:">
                    <b-form-select v-model="filters.competencia_mes" :options="[{text:'Todos',value:null},...Array.from({length:12},(_,i)=>({text:String(i+1).padStart(2,'0'),value:i+1}))]" />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Competência Ano:">
                    <b-form-input type="number" v-model="filters.competencia_ano" />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Situação:">
                    <b-form-select v-model="filters.status" :options="[{text:'Todas',value:null},{text:'Pendentes',value:0},{text:'Recebidas',value:1}]" />
                  </b-form-group>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right mb-2">
        <b-button variant="primary" @click="onPrimaryButtonClick">{{ showFilters ? 'Gerar relatório' : 'Filtros...' }}</b-button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoadingPdf" class="text-center py-5">
              <b-spinner label="Carregando..."></b-spinner>
              <div class="text-muted mt-2">Gerando relatório em PDF...</div>
            </div>
            <b-alert v-if="pdfError" variant="danger" show class="mb-3">{{ pdfError }}</b-alert>
            <div v-if="pdfSrc" class="pdf-container">
              <iframe :src="pdfSrc" width="100%" height="820" style="border: none;"></iframe>
            </div>
            <div v-else-if="!isLoadingPdf && showFilters" class="text-center text-muted py-5">
              Selecione os filtros e clique em "Gerar relatório" para visualizar o PDF aqui.
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.pdf-container {
  width: 100%;
  min-height: 820px;
}
</style>


